import { cn } from '@/utils';
import type { FC } from 'react';
import { memo, useMemo } from 'react';
import NlpNodeIcon from './nodes/nlp-extraction/icon';
import SemanticRulesExtractionNodeIcon from './nodes/semantic-rules-extraction/icon';
import StartNodeIcon from './nodes/start/icon';
import TableExtractionNodeIcon from './nodes/table-extraction/icon';
import HandWritingExtractionNodeIcon from './nodes/handwritting/icon';
import { NodeEnum } from './types';
import SealNodeIcon from './nodes/seal/icon';
import LargeModelExtractionNodeIcon from './nodes/llm/icon';
type BlockIconProps = {
  type: NodeEnum;
  className?: string;
  size?: 'small' | 'medium' | 'large';
};

const getIcon = (type: NodeEnum) => {
  return {
    [NodeEnum.Start]: StartNodeIcon,
    [NodeEnum.NlpExtract]: NlpNodeIcon,
    [NodeEnum.SemanticRulesExtraction]: SemanticRulesExtractionNodeIcon,
    [NodeEnum.TableExtraction]: TableExtractionNodeIcon,
    [NodeEnum.HandWritingExtraction]: HandWritingExtractionNodeIcon,
    [NodeEnum.SealExtraction]: SealNodeIcon,
    [NodeEnum.LargeModelExtraction]: LargeModelExtractionNodeIcon,
  }[type];
};

const IconSizeMap = {
  small: 'size-4',
  medium: 'size-6',
  large: 'size-8',
};

const BlockIcon: FC<BlockIconProps> = ({
  type,
  className,
  size = 'medium',
}) => {
  const Icon = useMemo(() => getIcon(type), [type, className, size]);
  return (
    <>
      <Icon className={cn(IconSizeMap[size], className)} />
    </>
  );
};

export default memo(BlockIcon);
